import {UploadStatus} from "./SlideData";

export default interface MusicData {
    id: string,
    url: string,
    title1?: string,
    title2?: string,
    duration: number,
    type: string,
    isActive: boolean,
    status: UploadStatus,
    uploadError?: string,
    uploadProgress?: number,
    createdAt?: number
}

export const MUSIC_TYPE_LOCAL = 'local';
export const MUSIC_TYPE_USER = 'user';